import React from "react";
import wrapper from "@app/store/store";
import "styles/globals.scss";
import App, { AppContext, AppProps } from "next/app";
import ThemeProvider from "@app/ThemeContext/ThemeProvider";
import { useRouter } from "next/router";
import { getTenantInfo } from "@app/services/tenant.service";
import { ssrCookieHeaders } from "@app/utils/api";

interface MyAppProps extends AppProps {
  tenantId: string | null;
}

function MyApp({ Component, pageProps, tenantId }: MyAppProps) {
  const router = useRouter();

  const { tenantId: tenantIdFromQuery } = router.query;

  const finalTenantId = tenantIdFromQuery || tenantId;

  return (
    <ThemeProvider tenantId={finalTenantId as string}>
      <Component {...pageProps} />
    </ThemeProvider>
  );
}

MyApp.getInitialProps = async (appContext: AppContext) => {
  const appProps = await App.getInitialProps(appContext);

  let tenantId: string | null = null;

  try {
    // Runs on the server, where `withCredentials` buys nothing — Node has no cookie jar. Forward the
    // visitor's own Cookie header so this call is made as them rather than anonymously.
    const tenantInfoRes = await getTenantInfo(ssrCookieHeaders(appContext.ctx?.req));
    tenantId = tenantInfoRes?.tenantInfo?._id || null;
  } catch (err) {
    console.error("Error fetching tenant info:", err);
  }

  return { ...appProps, tenantId };
};

export default wrapper.withRedux(MyApp);
